/**
 * Cloudflare Turnstile (mode „Managed“) for anonymous chat visitors. The site key is public.
 * Widget „hausverwalter.ai Kunden-Chat“, hosts hausverwalter.ai + portalzugang.de with subdomains.
 */

export const TURNSTILE_SITE_KEY = "0x4AAAAAAFhh1t0fZTg0D2Fl";
/** Cloudflare's documented test key: always passes. Non-prod hosts only. */
const TURNSTILE_TEST_SITE_KEY = "1x00000000000000000000BB";
const PROD_ROOT_HOSTS: readonly string[] = ["hausverwalter.ai", "portalzugang.de"];

/** Real key on our prod hosts and their subdomains; test key everywhere else (previews, localhost). */
export function turnstileSiteKeyForHost(hostname: string): string {
  const host = hostname.trim().toLowerCase();
  const isProdHost = PROD_ROOT_HOSTS.some((root) => host === root || host.endsWith(`.${root}`));
  return isProdHost ? TURNSTILE_SITE_KEY : TURNSTILE_TEST_SITE_KEY;
}

export const TURNSTILE_CHAT_ACTION = "chat_session";
export const TURNSTILE_SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
